import classnames from 'classnames';

import styles from 'molecules/Layout2Up/layout-2up.module.scss';

import type { FC, ReactNode } from 'react';

interface Layout2UpProps {
  left: ReactNode;
  right: ReactNode;
  classes?: {
    wrapper?: string;
    left?: string;
    right?: string;
  };
}

const Layout2Up: FC<Layout2UpProps> = ({ left, right, classes = {} }) => (
  <div
    className={classnames(styles.container, {
      [classes.wrapper || '']: classes.wrapper,
    })}
  >
    <div
      className={classnames(styles.left, {
        [classes.left || '']: classes.left,
      })}
    >
      {left}
    </div>
    <div
      className={classnames(styles.right, {
        [classes.right || '']: classes.right,
      })}
    >
      {right}
    </div>
  </div>
);

export default Layout2Up;
